module.exports = __webpack_public_path__ + "static/media/background2.6b715544.jpg";